				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentAndStatus } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class QBService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('QB');
	}
	
	connect(): Observable<any> {
		return this.myBaseService.post(null, this.url + '/Connect', true);
	}

	disconnect(): Observable<any> {
		return this.myBaseService.post(null, this.url + '/Disconnect', true);
	}

	auth(id: System.Guid, code:string , error:string, realmId:string) : Observable<string> {
		var urlStr = this.url + '/Auth?';
		urlStr += '&id=' + (id || '');
		urlStr += '&code=' + (code || '');
		urlStr += '&realmId=' + (realmId || '');
		urlStr += '&error=' + (error || '');
		return this.myBaseService.post(null, urlStr, true);
	}
}
				
